import { render, staticRenderFns } from "./proofListing.vue?vue&type=template&id=0a7d94a9&scoped=true&"
import script from "./proofListing.vue?vue&type=script&lang=js&"
export * from "./proofListing.vue?vue&type=script&lang=js&"
import style0 from "./proofListing.vue?vue&type=style&index=0&id=0a7d94a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d94a9",
  null
  
)

export default component.exports